export interface ITelephonyEventData {
  session:  string;
  dnis?:    string;
}

export interface ITelephonyUpdate {
  session:  string;
  state:    'held' | 'leg_a' | 'leg_b' | 'recover' | 'validate';
  success:  boolean;
  message?: string;
}
